module.exports = __webpack_public_path__ + "static/media/metropases.41ae481e.svg";